import type { IPageQueryParams } from './query-params-mixins';

export function paginateArray<T>(array: T[], { page, limit }: IPageQueryParams) {
	return page
		? array.slice((Number(page) - 1) * Number(limit), Number(page) * Number(limit))
		: array.slice(0, Number(limit));
}
